import createClient from 'openapi-fetch';

import type { components, paths } from './schema';

export type { components, paths };
export type Schemas = components['schemas'];

/** Header the server requires on every non-GET admin request (CSRF guard). */
export const CSRF_HEADER = { 'X-Requested-With': 'mock-sensors' } as const;

/** The two simulators the server runs side by side (docs/SPACES.md). */
export type Space = components['schemas']['Space'];

/** A client for one space: every call names it in the `x-mock-space` header. */
export function createApiClient(space: Space, baseUrl = '') {
	return createClient<paths>({ baseUrl, credentials: 'same-origin', headers: { ...CSRF_HEADER, 'x-mock-space': space } });
}
